module.exports = __webpack_public_path__ + "img/mc.4366bb68.svg";